import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Style.css';

const MacbookPro = () => {
  const navigate = useNavigate();
  const [fadeOut, setFadeOut] = useState(false);

  const handleGuestClick = () => {
    setFadeOut(true);
    setTimeout(() => {
      navigate('/career-pulse-loader');
    }, 600); // 600ms fade duration
  };

  return (
    <>
      <video autoPlay muted loop className="background-video">
        <source src="/background-video.mp4" type="video/mp4" />
      </video>

      <div
        className={`macbook-pro transition-opacity duration-700 ease-in-out ${
          fadeOut ? 'opacity-0' : 'opacity-100'
        }`}
      >
        <img className="logo-image" alt="Logo" src="/Logo.png" />

        <div className="logo-background">
          <div className="logo-background-2" />
        </div>

        <p className="welcome-to-let-s">
          Welcome to <br />
          Let’s Figure it Out
        </p>

        <div className="quote-container">
          <p className="text-wrapper">
            “The world is changing — but so are the opportunities.🔥”
          </p>
        </div>

        <div className="label">
          <div className="you-re-not-behind">
            Your Personal AI Guide: Ask Anything from Agriculture to AI.
          </div>
        </div>

        <button className="shimmer-button" onClick={handleGuestClick}>
          Be my Guest
          <img src="/Assets/Arrow-Icon.png" alt="arrow" className="inline ml-2 w-4 h-4" />
        </button>
      </div>
    </>
  );
};

export default MacbookPro;
